import { render, staticRenderFns } from "./TintCategories.vue?vue&type=template&id=705bbbbc&"
import script from "./TintCategories.vue?vue&type=script&lang=js&"
export * from "./TintCategories.vue?vue&type=script&lang=js&"
import style0 from "./TintCategories.vue?vue&type=style&index=0&id=705bbbbc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports